// Ochiq ariza sahifasi /apply, uz
export default {
  brand: "Haydovchilik ishlari",
  closedTitle: "Hozircha arizalar qabul qilinmayapti.",
  closedDesc: "Iltimos, keyinroq qayta kiring.",
  h1: "CDL-A yuk mashinasi haydovchisi ishiga ariza bering",
  lead: "1 daqiqa oladi. Rekruter sizga qo'ng'iroq qiladi.",
  fullName: "To'liq ism",
  phone: "Telefon",
  email: "Email",
  state: "Shtat",
  statePlaceholder: "Shtat",
  cdlClass: "CDL toifasi",
  classPlaceholder: "Toifa",
  classA: "A toifa",
  classB: "B toifa",
  classC: "C toifa",
  experience: "Haydovchilik tajribasi",
  choose: "Tanlang",
  exp: { lt1: "1 yildan kam", y1_2: "1–2 yil", y2_5: "2–5 yil", y5: "5+ yil" },
  equipment: "Qaysi texnikani haydamoqchisiz",
  website: "Veb-sayt",
  consent: "Haydovchilik ishlari bo'yicha telefon, SMS va email orqali bog'lanishlariga roziman. Rozilik ishga olish sharti emas. SMS va internet tariflari qo'llanishi mumkin.",
  submit: "Ariza yuborish",
  noSsn: "Bu formada SSN hech qachon so'ralmaydi.",
  sendFailed: "Arizani yuborib bo'lmadi. Internetni tekshirib, qayta urinib ko'ring.",
  errors: {
    name: "To'liq ismingizni kiriting",
    nameTwo: "Ism va familiyangizni kiriting",
    phone: "To'g'ri AQSh telefon raqamini kiriting",
    email: "To'g'ri email kiriting",
    state: "Shtatingizni tanlang",
    cdl: "CDL toifangizni tanlang",
    experience: "Tajribangizni tanlang",
    consent: "Rozilik majburiy",
  },
  thanks: "Rahmat, {{name}}!",
  thanksAnon: "Rahmat!",
  received: "Arizangiz qabul qilindi. Rekruter 1 ish kuni ichida qo'ng'iroq qiladi.",
  questions: "Savollar bormi? Rekruter qo'ng'irog'ida so'rang.",
  back: "{{company}} ga qaytish",
};
